<template>
  <gsp-dialog
    v-if="showEl"
    :hidden="applyMainHidden"
    aria-modal="true"
    @dismiss="emitDismiss"
    backdrop="static"
    role="dialog"
  >
    <slot />
  </gsp-dialog>
</template>

<script setup>
import { ref, watch, inject } from "vue";
import showElOnMounted from "~/composables/show-el-on-mounted";

const applyMainHidden = ref(false);
const props = defineProps({
  hidden: {
    type: Boolean,
    default: false,
  },
  opener: {
    type: String,
    default: null,
  },
});

const emit = defineEmits({
  dismiss: null,
});

watch(
  () => props.hidden,
  (val) => {
    if (val) {
      applyMainHidden.value = val;
    } else {
      setTimeout(() => {
        applyMainHidden.value = val;
      }, 50);
    }
  },
  { immediate: true }
);

const showEl = showElOnMounted();

const openerRef = inject(props.opener);

function emitDismiss(event) {
  setTimeout(() => {
    openerRef?.value?.focus()
  }, 100);
  emit("dismiss", event);
}

defineExpose({ emitDismiss });
</script>
